module.exports = __webpack_public_path__ + "media/pages/street_beat-59ece761.jpg";